// React
import React, {useContext} from 'react';
import 'emoji-mart/css/emoji-mart.css';

import {Box, Stack, Typography} from '@wellstone-solutions/web';

import {MemberDetailTabContext} from '../../contexts/MemberDetailTabContext';

import {CheckinsList} from './CheckinsList';

export const GeneralTabContent = () => {
  const {member, getChatModule} = useContext(MemberDetailTabContext);

  return (
    <Stack
      direction={{xs: 'column', md: 'row'}}
      spacing={3}
      alignItems={{md: 'flex-start'}}
      sx={{
        minHeight: {xs: '880px', md: '440px'},
        marginBottom: '40px',
      }}>
      <CheckinsList memberId={member.id} />
      <Box
        sx={{
          flex: 1,
          minHeight: '440px',
          display: 'flex',
          flexDirection: 'column',
        }}>
        <Typography variant="h5" gutterBottom>
          Chat
        </Typography>
        {getChatModule()}
      </Box>
    </Stack>
  );
};
